import { YACHT_FACILITIES } from '../helpers/constants'

export default {
  filters: {
    formatPrice (price) {
      return price.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  },
  computed: {
    cabinDescriptions () {
      const cabin = this.yacht.__odyssey_number_of_cabins === 1 
        ? '1 cabin'
        : `${this.yacht.__odyssey_number_of_cabins} cabins`
      
      const guests = this.yacht.__odyssey_max_occupancy === 1
        ? '1 guest'
        : `${this.yacht.__odyssey_max_occupancy} guests`

      return `${cabin}, up to ${guests}`
    },
    crewDisplay () {
      if (Number(this.yacht.__odyssey_crew).toString() === this.yacht.__odyssey_crew) {
        return `${this.yacht.__odyssey_crew} crew`
      }
      else {
        return this.yacht.__odyssey_crew
      }
    },
    topFacilities () {
      return this.yacht.__odyssey_inclusions
        .filter(incl => incl.list_id === YACHT_FACILITIES)
        .filter(incl => incl.order === 1)
    }
  }
}